export default __webpack_public_path__ + "static/media/9.d1ed8f6b.png";